import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      <span className="sr-only-seo">human on rent privacy policy, boyfriend on rent privacy, girlfriend on rent data protection</span>

      <Header />

      <main className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-light text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-gray-500 mb-12">Last updated: January 2024</p>

          <div className="legal-content">
            <h2>1. Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>When you create an account, we collect:</p>
            <ul>
              <li>Name and contact information (phone number, email)</li>
              <li>Identity verification documents (Aadhaar, PAN for providers)</li>
              <li>Profile information (bio, photos, services offered)</li>
              <li>Payment information (processed securely via payment gateways)</li>
              <li>Location data (city, pincode for service matching)</li>
            </ul>

            <h3>Usage Information</h3>
            <p>We automatically collect:</p>
            <ul>
              <li>Device information (browser type, operating system)</li>
              <li>Log data (IP address, access times, pages viewed)</li>
              <li>Booking history and transaction records</li>
              <li>Communication logs between users</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>Provide and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Verify identity and prevent fraud</li>
              <li>Match hirers with suitable providers</li>
              <li>Send service updates and promotional communications</li>
              <li>Respond to customer support requests</li>
              <li>Ensure platform safety and security</li>
            </ul>

            <h2>3. Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Other Users:</strong> Limited profile information is shared to facilitate bookings</li>
              <li><strong>Service Providers:</strong> Payment processors, verification services, cloud storage</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect rights and safety</li>
              <li><strong>Business Transfers:</strong> In case of merger, acquisition, or asset sale</li>
            </ul>
            <p>We never sell your personal information to third parties for marketing purposes.</p>

            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures including:</p>
            <ul>
              <li>SSL/TLS encryption for data transmission</li>
              <li>Secure payment processing through certified gateways</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>Access controls and authentication protocols</li>
              <li>Encrypted storage for sensitive data</li>
            </ul>

            <h2>5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Delete your account and associated data</li>
              <li>Object to certain data processing</li>
              <li>Data portability (receive your data in a structured format)</li>
              <li>Withdraw consent at any time</li>
            </ul>

            <h2>6. Cookies and Tracking</h2>
            <p>We use cookies and similar technologies to:</p>
            <ul>
              <li>Remember your preferences and login status</li>
              <li>Analyze site usage and improve performance</li>
              <li>Provide personalized content and recommendations</li>
            </ul>
            <p>You can control cookies through your browser settings.</p>

            <h2>7. Data Retention</h2>
            <p>We retain your data for as long as your account is active or as needed to provide services. After account deletion, we may retain certain information for legal compliance, dispute resolution, and enforcement purposes.</p>

            <h2>8. Children's Privacy</h2>
            <p>Our services are not intended for individuals under 18 years of age. We do not knowingly collect information from minors.</p>

            <h2>9. Changes to Privacy Policy</h2>
            <p>We may update this policy periodically. We will notify you of significant changes via email or platform notification.</p>

            <h2>10. Contact Us</h2>
            <p>For privacy-related questions or to exercise your rights, contact us at:</p>
            <ul>
              <li>Email: privacy@humanonrent.com</li>
              <li>Phone: +91 98765 43210</li>
              <li>Address: Mumbai, Maharashtra, India</li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
